import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import {
    createHandlerChainRunner,
    executeAwaitableHandlerChain,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";
import sortProductCollections from "@insite/client-framework/Store/Data/Products/Handlers/SortProductCollections";
import { GetProductByIdApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

type Parameter = GetProductByIdApiV2Parameter & { allSites?: boolean } & HasOnSuccess<ProductModel>;

type Props = {
    apiParameter: GetProductByIdApiV2Parameter & { allSites?: boolean };
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

const productsUrl = "/api/v2/products";

export const DispatchBeginLoadProduct: HandlerType = props => {
    throwErrorIfTesting();

    props.dispatch({
        type: "Data/Products/BeginLoadProduct",
        id: props.parameter.id,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, ...apiParameter } = props.parameter as any;
    props.apiParameter = apiParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const { id, ...query } = props.apiParameter as any;
    props.apiResult = await get<ProductModel>(`${productsUrl}/${id}`, query);
};

export const SortCollections: HandlerType = async props => {
    await executeAwaitableHandlerChain(sortProductCollections, { products: [props.apiResult] }, props);
};

export const DispatchCompleteLoadProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/Products/CompleteLoadProduct",
        model: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    SortCollections,
    DispatchCompleteLoadProduct,
    ExecuteOnSuccessCallback,
];

const loadProduct = createHandlerChainRunner(chain, "LoadProduct");
export default loadProduct;
